import { initFaqSection } from "@/modules/section-faq";
import { initFooterSection } from "@/modules/section-footer";
import ready from "@/scripts/helpers/dom/ready";
import { Slicker } from '@rooi/slicker/esm2015/index';
import cookiePopup from "@/modules/popup-cookie";
import initMicroModal from "@/modules/modal/modal.js";
import 'select-pure/dist/index.js';
import JustValidate from 'just-validate';
import { headerFunctions } from "@/modules/section-header";


const slicker = new Slicker(document.querySelector('.js-slider'), {
  dots: false,
  arrows: false,
  infinite: true,
  speed: 6000,
	autoplaySpeed: 0,
  slidesToScroll: 1,
  centerMode: false,
  variableWidth: true,
  draggable: true,
  autoplay: true,
	swipeToSlide: true,
	pauseOnHover: false,
	fade: false,
	cssEase: 'linear',
	useTransform: false
});

const cards = document.querySelectorAll('.card');

if (cards) {
  cards.forEach(card => {
    card.addEventListener('click', e => {
      if (card.hasAttribute('href')) {
        window.location.href = card.getAttribute('href');
      }
      else if (card.querySelector('.card__title-link')) {
        window.location.href = card.querySelector('.card__title-link').getAttribute('href');
      }
      else if (card.querySelector('.card__title-link')) {
        window.location.href = card.querySelector('.card__title-link').getAttribute('href');
      }
    });
  });
}

if (document.querySelector('#modal-form')) {
  const validator = new JustValidate('#modal-form', {
    errorFieldStyle: {
      borderColor: '#EA593C',
    },
    errorLabelStyle: {
      color: '#EA593C',
      fontFamily: "'Open Sans', Arial",
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      paddingTop: '4px',
    },
    focusInvalidField: true,
  });

  const credentialsValidation = () => {
    const firstName = document.querySelector('#first-name').value
    const lastName = document.querySelector('#last-name').value

    return firstName === lastName ? false : true;
  };

  const formInputFields = document.querySelectorAll(".form-field-input, .form-field-textarea");

  [...formInputFields].forEach((inputElement) => {
    inputElement.addEventListener("input", () => {
      const inputValue = inputElement.value;

      const trimmedValue = inputValue.replace(/^\s+/, '');

      if (trimmedValue !== inputValue) {
        inputElement.value = trimmedValue;
      }
    });
  });

  const emailField = document.getElementById('email');
  if (emailField) {
    const emailInputHandler = () => {
      var trimmedEmailValue = emailField.value;
      emailField.value = '';
      emailField.value = trimmedEmailValue;
    };
    emailField.addEventListener("input", emailInputHandler);
  }

  validator
    .addField('#first-name', [
      {
        rule: 'required',
        errorMessage: 'Please enter your first name',
      },
      {
        rule: 'customRegexp',
        value: /^[A-Za-zÀ-ÖØ-öø-ÿА-Яа-я ]+$/,
        errorMessage: 'Please enter a valid name',
      },
      {
        rule: 'minLength',
        value: 2,
        errorMessage: 'This value length is invalid. It should be between 2 and 40 characters long',
      },
      {
        rule: 'maxLength',
        value: 40,
        errorMessage: 'This value length is invalid. It should be between 2 and 40 characters long',
      },
      {
        validator: credentialsValidation,
        errorMessage: 'First name should not be equal to last name',
      },
    ])
    .addField('#last-name', [
      {
        rule: 'required',
        errorMessage: 'Please enter your last name',
      },
      {
        rule: 'customRegexp',
        value: /^[A-Za-zÀ-ÖØ-öø-ÿА-Яа-я ]+$/,
        errorMessage: 'Please enter a valid last name',
      },
      {
        rule: 'minLength',
        value: 2,
        errorMessage: 'This value length is invalid. It should be between 2 and 80 characters long',
      },
      {
        rule: 'maxLength',
        value: 80,
        errorMessage: 'This value length is invalid. It should be between 2 and 80 characters long',
      },
      {
        validator: credentialsValidation,
        errorMessage: 'First name should not be equal to last name',
      },
    ])
    .addField('#email', [
      {
        rule: 'required',
        errorMessage: 'Please enter your email',
      },
      {
        rule: 'email',
        errorMessage: 'Please enter a valid email',
      },
      {
        rule: 'customRegexp',
        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        errorMessage: 'Please enter a valid email',
      },
      {
        rule: 'minLength',
        value: 2,
        errorMessage: 'This value length is invalid. It should be between 2 and 80 characters long',
      },
      {
        rule: 'maxLength',
        value: 80,
        errorMessage: 'This value length is invalid. It should be between 2 and 80 characters long',
      },
    ])
    .addField('#phone-number', [
      {
        rule: 'required',
        errorMessage: 'Please enter your phone number',
      },
      {
        rule: 'customRegexp',
        value: /^\+?\d+[-.\s]?(?:\(\d{3}\)[-.\s]?)?\d+[-.\s]?\d+$/,
        errorMessage: 'Please enter a valid phone number',
      },
      {
        rule: 'minLength',
        value: 5,
        errorMessage: 'This value length is invalid. It should be between 5 and 40 characters long',
      },
      {
        rule: 'maxLength',
        value: 40,
        errorMessage: 'This value length is invalid. It should be between 5 and 40 characters long',
      },
    ])
    .addField('#company-name', [
      {
        rule: 'required',
        errorMessage: 'Please enter your company name',
      },
      {
        rule: 'customRegexp',
        value: /^[A-Za-zÀ-ÖØ-öø-ÿА-Яа-я\d ]+$/,
        errorMessage: 'Please enter a valid company name',
      },
      {
        rule: 'minLength',
        value: 2,
        errorMessage: 'This value length is invalid. It should be between 2 and 255 characters long',
      },
      {
        rule: 'maxLength',
        value: 254,
        errorMessage: 'This value length is invalid. It should be between 2 and 255 characters long',
      },
    ])
    .addField('#job-title', [
      {
        rule: 'required',
        errorMessage: 'Please enter your job title',
      },
      {
        rule: 'customRegexp',
        value: /^[A-Za-zÀ-ÖØ-öø-ÿА-Яа-я\d ]+$/,
        errorMessage: 'Please enter a job title',
      },
      {
        rule: 'minLength',
        value: 2,
        errorMessage: 'This value length is invalid. It should be between 2 and 120 characters long',
      },
      {
        rule: 'maxLength',
        value: 120,
        errorMessage: 'This value length is invalid. It should be between 2 and 120 characters long',
      },
    ])
    .addField('#company-size', [
      {
        rule: 'required',
        errorMessage: 'Please enter your company size',
      },
    ])
    .addField('#questions-comments', [
      {
        rule: 'maxLength',
        value: 1000,
        errorMessage: 'This value length is invalid. It should be up to 1000 characters long.',
      },
    ]);

  validator.onSuccess(function(event) {
    MicroModal.close('agreement-modal');
    MicroModal.show('agreement-modal--success');
    document.body.classList.add("scroll-locked");

    const form = document.querySelector('#modal-form');
    const successCloseButton = document.querySelector('.js-success-close');
    const successOverlay = document.querySelector('#agreement-modal--success .modal__overlay');
    const successModal = document.querySelector('#agreement-modal--success');

    let autoCloseSuccessWindow = setTimeout(() => {
      if (successModal.classList.contains('is-open')) {
        MicroModal.close('agreement-modal--success');
        document.body.classList.remove("scroll-locked");
      }
    }, '5000');

    successCloseButton.addEventListener('click', () => {
      document.body.classList.remove("scroll-locked");
      clearTimeout(autoCloseSuccessWindow);
    });

    successOverlay.addEventListener('click', e => {
      if (!e.target.closest('.modal__container')) {
        document.body.classList.remove("scroll-locked");
        clearTimeout(autoCloseSuccessWindow);
      }
    });

    [...formInputFields].forEach(field => {
      const fieldValue = field.value;
      const trimmedValue = fieldValue.trim();
      field.value = trimmedValue;
    });

    const formData = new FormData(event.target);
    const formDataObject = Object.fromEntries([...formData.entries()]);
    const token = document.querySelector('meta[name="csrf-token"]');
    const url = form.getAttribute('data-url');

    console.log("form data:", formDataObject);
    console.log("token:", token);
    console.log("submit url:", url);

    if (token) {
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': token.content
        },
        body: JSON.stringify(formDataObject)
      })
        .then(response => response.json())
        .then(data => {
          console.log("validator:", data);
        })
        .catch(error => {
          console.error("validator:", error);
        });
    } else {
      console.log("validator: X-CSRF-TOKEN is missing");
    }

    form.reset();
    validator.refresh();
  });
}

ready( () => {
  headerFunctions();
  initMicroModal();
  initFaqSection();
  initFooterSection();
  setTimeout(() => {
    cookiePopup();
  }, 4000);
});